// extracted by mini-css-extract-plugin
export default {"multiline-text":"merge-user-modal__multiline-text--fZPjL","multilineText":"merge-user-modal__multiline-text--fZPjL"};